<template>
  <div class="app-container">
    <h1>{{ $tc('message.home.menu.cuotas.titulo', 2) }}</h1>
    <div><CardList :cards="opciones"></CardList></div>
  </div>
</template>

<script>
import { CardList } from '@/components';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'cuotasIndex',
  data() {
    return {
      cardList: [
        {
          name: this.$t('message.cuotas.menu.presentar.titulo'),
          detail: this.$t('message.cuotas.menu.presentar.detalle', {
            tipo: this.$options.filters.tipoEmpresaName(
              this.$store.getters.empresaSelected.cdtipemp
            )
          }),
          icon: 'description',
          path: '/cuotas/presentacion-'
        },
        {
          name: this.$t('message.cuotas.menu.consultar.titulo'),
          detail: this.$t('message.cuotas.menu.consultar.detalle', {
            tipo: this.$options.filters.tipoEmpresaName(
              this.$store.getters.empresaSelected.cdtipemp
            )
          }),
          icon: 'format_list_bulleted',
          path: '/cuotas/consulta'
        }
      ]
    };
  },
  components: {
    CardList
  },
  created() {
    this.setBreadcrumb({
      breadcrumb: [{ text: 'Inicio', to: '/' }, { text: 'Cuotas', to: '/cuotas' }],
      menuSelected: '/cuotas'
    });
    // Depende del tipo de empresa redirigimos a un sitio o a otro.
    this.cardList[0].path += this.$options.filters.tipoEmpresaName(this.empresaSelected.cdtipemp);
  },
  computed: {
    ...mapGetters(['empresaSelected']),
    opciones() {
      // gas y electricidad
      return this.cardList.filter(
        item => !item.path.includes('/cuotas/presentacion-') || !this.empresaSelected.febaja
      );
    }
  },
  methods: {
    ...mapActions(['setBreadcrumb'])
  }
};
</script>
